// extracted by mini-css-extract-plugin
module.exports = {"loader":"SpinnerRectangles_loader__3t7_I","load1":"SpinnerRectangles_load1__1kRHZ"};